import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ChannelItem } from 'src/app/models/channel_item';
import { LoginService } from 'src/app/managers/login.service';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { environment } from 'src/environments/environment';
import { RssFeedService } from 'src/app/managers/rssFeed.service';
import { CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';

@Component({
  selector: 'app-today-feed-item',
  templateUrl: './today-feed-item.component.html',
  styleUrls: ['./today-feed-item.component.css']
})
export class TodayFeedItemComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() channelItem: ChannelItem;
  @Input() itemImageWidth: string;
  @Input() itemImageHeight: string;
  @Input() cardSizeWidth: string;
  @Input() cardSizeHeight: string;
  @Input() isFavoriteItem: boolean;
  @Output() onFavoriteItemAdded: EventEmitter<ChannelItem>;
  @Output() onFavoriteItemRemove: EventEmitter<ChannelItem>;
  defaultImageUrl: string;

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, private _rssFeedService: RssFeedService,
              private _snackBar: MatSnackBar) { 
    super(route, loginManager, clientConfig, dialog);

    this.onFavoriteItemAdded = new EventEmitter<ChannelItem>();
    this.onFavoriteItemRemove = new EventEmitter<ChannelItem>();;
    this.defaultImageUrl = environment.defaultChannelItemImageUrl;
  }

  ngOnInit() {
    this.dataSource = this.channelItem;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  itemClick() {
    window.open(this.dataSource.ItemUrl);
  }

  async addToFavorite() {
    let items: ChannelItem[] = [];
    items.push(this.channelItem);
    let coreRespMsg = await this._rssFeedService.addChannelItemsToFavoriteAsync(this.getLoggedinUser(), items);

    if (coreRespMsg.Status === CoreResponseStatus.OK) {
      this.onFavoriteItemAdded.emit(this.channelItem);
      this._snackBar.open('The item bookmarked successfully.', 'OK', { duration: this._successMsgDuration });
    }    
    else {
      this._snackBar.open('Failed to add the item: ' + coreRespMsg.Message, 'OK', { duration: this._failMsgDuration });
    }
  }

  removeFromFavorite() {
    this.onFavoriteItemRemove.emit(this.channelItem);    
  }
}
